import React from "react";
import { Link } from "react-router-dom";
import { LogIn, ShieldCheck } from "lucide-react";

/**
 * Slim utility bar above the main navbar. Always visible on home,
 * with quick access to Parent and Admin login portals.
 */
export default function TopBar() {
  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] bg-[#0F1B47] text-[#FDFDF9] text-[12px]"
      data-testid="site-topbar"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-9 flex items-center justify-between">
        <div className="flex items-center gap-2 font-medium tracking-wide opacity-90">
          <span className="hidden sm:inline">Admissions Open 2026 — 27</span>
          <span className="sm:hidden">Admissions 2026 — 27</span>
          <span className="hidden md:inline opacity-50 mx-2">·</span>
          <span className="hidden md:inline opacity-70">+91 97405 31855</span>
        </div>
        <div className="flex items-center gap-2 sm:gap-3">
          <Link
            to="/parent/login"
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full hover:bg-[#FDFDF9]/10 transition-colors font-semibold"
            data-testid="topbar-parent-login"
          >
            <LogIn size={13} className="text-[#C6D947]" />
            <span>Parent Login</span>
          </Link>
          <span className="opacity-30">|</span>
          <Link
            to="/admin/login"
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full hover:bg-[#FDFDF9]/10 transition-colors font-semibold"
            data-testid="topbar-admin-login"
          >
            <ShieldCheck size={13} className="text-[#3AB0D6]" />
            <span>Admin Login</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
